import {
  STATUS_FILTER,
  BRANCH_FILTER,
  ZONE_FILTER,
  INVOICE_COURIER_STATUS_OPTIONS,
  OUTGOING_INVOICE_SERIAL_NO_FILTER,
} from "../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");

// yyyy-mm-dd, the format the native date input expects
const todayDate = () => new Date().toISOString().slice(0, 10);

export const basicFormData = () => ({
  inputData: {
    branch_id: "",
    zone_id: "",
    invoice_number: "",
    invoice_date: todayDate(),
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "outgoing_invoices",
    schema: schema,
    include: [
      {
        model: "branch_masters",
        as: "branch",
      },
      {
        model: "zone_masters",
        as: "zone",
      },
      // {
      //   model: "dispatcheds",
      //   as: "dispatcheds",
      // },
    ],
  };

  const navigatePage = { back: "/outgoing-invoice-list" };

  const headerName = "Outgoing Invoice";

  const validationType = "OutgoingInvoicesCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "outgoing_invoices",
    schema: schema,
    include: [
      {
        model: "branch_masters",
        as: "branch",
      },
      {
        model: "zone_masters",
        as: "zone",
      },
    ],
  };

  const navigatePage = {
    create: "/outgoing-invoice-create",
    edit: "/outgoing-invoice-create",
    view: "/outgoing-invoice-view",
  };

  // NOTE: the column on outgoing_invoices is `invoice_number`; the old
  // `outgoing_invoice_no` does not exist and made every search fail.
  const searchfields = [
    "invoice_number",
    "courier_name",
    "courier_docket_number",
    "zone.zone_name",
    "branch.branch_name",
  ];

  const filterConfig = [
    OUTGOING_INVOICE_SERIAL_NO_FILTER,
    ZONE_FILTER,
    BRANCH_FILTER,
    {
      key: "status",
      label: "Courier Status",
      width: 185,
      options: INVOICE_COURIER_STATUS_OPTIONS,
    },
    STATUS_FILTER,
  ];

  const headerName = "Outgoing Invoice";
  const endpoint = "/getRecords";
  const exportFileName = "OutgoingInvoicesData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

export const exportPageData = {
  modelName: "material_intakes",
  schema: schema,
  include: [
    { model: "material_masters", as: "material" },
    { model: "client_masters", as: "customer" },
    { model: "user_masters", as: "received_by_user" },
    { model: "user_masters", as: "inspected_by_user" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
